import React from "react";
import case2 from "../images/12.jpg";
import case3 from "../images/Flow Chart.png";
// import moleculeImg from "../images/10.jpg"; // Replacing case1 with this

const CaseStudy = () => {
  return (
    <div className="w-full bg-black text-white overflow-x-hidden">
      {/* Header Section */}
      <section className="w-full flex flex-col md:flex-row items-center justify-between px-4 sm:px-6 md:px-10 lg:px-24 py-12 gap-8 bg-black">
        <div className="w-full md:w-1/2 space-y-4">
          <h1 className="text-2xl sm:text-3xl lg:text-5xl font-bold leading-tight">
            Structure-Guided Design of <br /> Selective CDK2 Inhibitors
          </h1>
          <p className="text-gray-300 text-base sm:text-lg lg:text-xl">
            Utilizing CASCADE’s approach to Design  CDK2 Inhibitors.
          </p>
        </div>
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={case3}
            alt="Molecule"
            className="w-full max-w-xl h-auto object-contain"
          />
        </div>
      </section>

      {/* Stats + Content Section */}
      <section className="w-full bg-black">
        {/* Stats Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 text-center border-t border-gray-800">
          {["150", "36", "4", "7.3 nM"].map((value, i) => (
            <div
              key={i}
              className={`py-10 px-4 min-h-[180px] flex flex-col justify-center ${i !== 3 ? "border-r" : ""
                } border-gray-800`}
            >
              <div className="text-xl sm:text-2xl md:text-3xl lg:text-5xl font-bold text-purple-400">
                {value}
              </div>

              <p className="text-gray-300 mt-2 text-sm sm:text-base">
                {[
                  "Hit Like Molecules Selected",
                  "Molecules tested",
                  "Potent Molecules Identified",
                  "IC50 value",
                ][i]}
              </p>
            </div>
          ))}
        </div>

        {/* Content Section */}
        <div className="flex flex-col lg:flex-row items-start justify-between px-4 sm:px-6 md:px-10 lg:px-24 py-16 bg-white text-base sm:text-lg lg:text-xl space-y-10 lg:space-y-0 lg:space-x-0">
          {/* Background */}
          <div className="flex-1 space-y-6 lg:pr-6">
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-800 mb-4 text-center">Background</h2>
            <ul className="list-disc text-gray-600 pl-5 space-y-4 text-justify">
              <li>CDK2 controls cell cycle progression, especially the G1-S phase.</li>
              <li>Its overactivation is linked to cancer and uncontrolled cell growth.</li>
              <li>Selective CDK2 inhibitors can induce tumor cell cycle arrest and apoptosis, offering targeted cancer therapy.</li>
            </ul>
          </div>

          {/* Methodology with vertical dotted line left/right on large screens */}
          <div className="flex-1 space-y-6 lg:px-6 border-l border-r border-gray-400 border-dotted hidden lg:block">
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-800 mb-4 text-center">Methodology</h2>
            <ul className="list-disc text-gray-600 pl-5 space-y-4 text-justify">
              <li>AI-driven molecular design targeting kinase selectivity motifs.</li>
              <li>Filtering & optimization using binding energy, drug-likeness, and synthesis feasibility.</li>
              <li>Docking & validation through gatekeeper-focused docking and enzymatic assay testing of top hits.</li>
            </ul>
          </div>

          {/* On small screens show Methodology without border */}
          <div className="flex-1 space-y-6 lg:hidden">
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-800 mb-4 text-center">Methodology</h2>
            <ul className="list-disc text-gray-600 pl-5 space-y-4 text-justify">
              <li>AI-driven molecular design targeting kinase selectivity motifs.</li>
              <li>Filtering & optimization using binding energy, drug-likeness, and synthesis feasibility.</li>
              <li>Docking & validation through gatekeeper-focused docking and enzymatic assay testing of top hits.</li>
            </ul>
          </div>

          {/* Results */}
          <div className="flex-1 space-y-6 lg:pl-6">
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-800 text-center mb-4">Results</h2>
            <ul className="space-y-4">
              <li className="flex items-start gap-2 text-gray-600 text-justify">
                <span className="text-2xl text-[#6FC5F0]">•</span>
                <span><span className="text-black font-semibold">Promising activity:</span> 25% of molecules showed &gt;70% inhibition; 5 compounds had IC₅₀ &lt; 0.9 µM.</span>
              </li>
              <li className="flex items-start gap-2 text-gray-600 text-justify">
                <span className="text-2xl text-[#6FC5F0]">•</span>
                <span><span className="text-black font-semibold">Lead candidate:</span> CTX-C2A17 identified as lead with an IC₅₀ of 7.3 nM.</span>
              </li>
              <li className="flex items-start gap-2 text-gray-600 text-justify">
                <span className="text-2xl text-[#6FC5F0]">•</span>
                <span><span className="text-black font-semibold">Next steps:</span> Advancing to in vivo studies and toxicity profiling.</span>
              </li>
            </ul>
          </div>
        </div>

      </section>

      {/* Full Screen Image */}
      <section className="min-h-[60vh] sm:min-h-screen w-full bg-white flex items-center justify-center px-4">
        <img src={case2} alt="Case Study 2" className="w-full max-w-7xl h-auto object-contain" />
      </section>
    </div>
  );
};

export default CaseStudy;
